import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import ClarityLoader from "@/components/ClarityLoader";
import GoogleAdsLoader from "@/components/GoogleAdsLoader";
import AutoTranslator from "@/components/AutoTranslator";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";
import Confidentialite from "@/pages/Confidentialite";
import Reservation from "@/pages/Reservation";
import Accelere from "@/pages/Accelere";
import Moto from "@/pages/Moto";
import PermisBoiteAuto from "@/pages/PermisBoiteAuto";
import AutoEcoleParis from "@/pages/AutoEcoleParis";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PermisBoiteManuelle from "@/pages/PermisBoiteManuelle";
import ConduiteAccompagnee from "@/pages/ConduiteAccompagnee";
import CodeDeLaRoute from "@/pages/CodeDeLaRoute";
import BlogIndex from "@/pages/BlogIndex";
import BlogArticle from "@/pages/BlogArticle";
import AppShell from "@/pages/elearning/AppShell";
import Dashboard from "@/pages/elearning/Dashboard";
import Courses from "@/pages/elearning/Courses";
import Quiz from "@/pages/elearning/Quiz";
import UsersAdmin from "@/pages/elearning/UsersAdmin";
import CoursesAdmin from "@/pages/elearning/CoursesAdmin";
import CourseDetail from "@/pages/elearning/CourseDetail";
import Leaderboard from "@/pages/elearning/Leaderboard";
import Account from "@/pages/elearning/Account";
import Settings from "@/pages/elearning/Settings";
import Progress from "@/pages/elearning/Progress";
import AdsAdmin from "@/pages/elearning/AdsAdmin";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    }
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <CookieBanner />
          <ClarityLoader />
          <GoogleAdsLoader />
          <AutoTranslator />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/accelere" element={<Accelere />} />
            <Route path="/moto" element={<Moto />} />
            <Route path="/permis-boite-automatique" element={<PermisBoiteAuto />} />
            <Route path="/auto-ecole-paris" element={<AutoEcoleParis />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/permis-boite-manuelle" element={<PermisBoiteManuelle />} />
            <Route path="/conduite-accompagnee" element={<ConduiteAccompagnee />} />
            <Route path="/code-de-la-route" element={<CodeDeLaRoute />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="courses" element={<Courses />} />
              <Route path="courses/:cid" element={<CourseDetail />} />
              <Route path="courses/:cid/quiz/:level" element={<Quiz />} />
              <Route path="users" element={<ProtectedRoute roles={["super_admin","admin","mentor"]}><UsersAdmin /></ProtectedRoute>} />
              <Route path="admin/courses" element={<ProtectedRoute roles={["super_admin","admin"]}><CoursesAdmin /></ProtectedRoute>} />
              <Route path="admin/progress" element={<ProtectedRoute roles={["super_admin","admin"]}><Progress /></ProtectedRoute>} />
              <Route path="admin/ads" element={<ProtectedRoute roles={["super_admin","communication"]}><AdsAdmin /></ProtectedRoute>} />
              <Route path="admin/settings" element={<ProtectedRoute roles={["super_admin"]}><Settings /></ProtectedRoute>} />
              <Route path="leaderboard" element={<Leaderboard />} />
              <Route path="compte" element={<Account />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-right" richColors offset={24} />
    </div>
  );
}

export default App;
